import { Drawer, DrawerProps, styled } from '@mui/material';
import { ReactElement } from 'react';

import { AccountMenuContent } from './account-menu-content';

const StyledDrawer = styled(Drawer)(() => ({
    'hr:last-of-type': {
        marginTop: 'auto',
    },
}));

type AccountMenuMobileProps = DrawerProps;

export const AccountMenuMobile = (props: AccountMenuMobileProps): ReactElement => {
    const { ...drawerProps } = props;

    return (
        <StyledDrawer
            {...drawerProps}
            PaperProps={{ sx: { width: 264, pb: 1, borderTopLeftRadius: 4, borderBottomLeftRadius: 4 } }}
            anchor="right"
        >
            <AccountMenuContent onClose={props.onClose} />
        </StyledDrawer>
    );
};
